module.exports = __webpack_public_path__ + "img/list.a152072e.svg";